// LLM generated - Model Claude Opus 4
import { useEffect, useRef, useMemo } from 'react';

import { gameLiveUpdatesManager, getGameChannelName } from '../services/gameLiveUpdates.service';

export { getGameChannelName };

type UseGamePusherOptions = {
  eventIds: string[];
  source: string;
  enabled?: boolean;
};

type UseGamePusherReturn = {
  activeSubscriptions: number;
};

export function useGamePusher({
  eventIds,
  source,
  enabled = true,
}: UseGamePusherOptions): UseGamePusherReturn {
  const previousEventIdsRef = useRef<Set<string>>(new Set());

  const eventIdSet = useMemo(() => new Set(eventIds), [eventIds]);

  useEffect(() => {
    if (!enabled) {
      for (const eventId of previousEventIdsRef.current) {
        gameLiveUpdatesManager.unsubscribe(source, eventId);
      }
      previousEventIdsRef.current = new Set();
      return;
    }

    const prev = previousEventIdsRef.current;
    const curr = eventIdSet;

    for (const eventId of curr) {
      if (!prev.has(eventId)) {
        gameLiveUpdatesManager.subscribe(source, eventId);
      }
    }

    for (const eventId of prev) {
      if (!curr.has(eventId)) {
        gameLiveUpdatesManager.unsubscribe(source, eventId);
      }
    }

    previousEventIdsRef.current = new Set(curr);
  }, [enabled, eventIdSet, source]);

  useEffect(
    () => () => {
      for (const eventId of previousEventIdsRef.current) {
        gameLiveUpdatesManager.unsubscribe(source, eventId);
      }
      previousEventIdsRef.current = new Set();
    },
    [source]
  );

  return {
    activeSubscriptions: eventIdSet.size,
  };
}
